import { AuthService } from './services/auth.services';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet><ngx-loading-bar></ngx-loading-bar><ngx-spinner bdColor = "rgba(60,60,60, .5)" color = "#8F3F93" type = "ball-pulse" size = "medium" ></ngx-spinner>'
})
export class AppComponent implements OnInit {
  constructor(private router: Router, private translate: TranslateService) {
    translate.setDefaultLang('en');
    if (window.localStorage.getItem('tokenLanguage') !== null) {
      translate.use(window.localStorage.getItem('tokenLanguage'));
    }
  }

  ngOnInit() {
    this.router.events.subscribe(evt => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts